/* CUSTOM_ECORE_BY_CLAUDE — universal collection drill-down section.
   State machine: collapsed (all parents) <-> expanded (one parent + its
   subs). First click on a parent drills down (preventDefault). Second
   click on the same (now-active) parent allows the link to navigate.
   Click on a different parent: switch active parent. Back button or
   Escape: collapse. Keyboard nav: Tab/Shift-Tab walks focus, Enter
   activates, Escape collapses. */

(function () {
  'use strict';

  function CategoryDrill(section) {
    this.section = section;
    this.parents = section.querySelectorAll('.ecore-drill__parent');
    this.triggers = section.querySelectorAll('[data-drill-trigger]');
    this.backBtn = section.querySelector('[data-drill-back]');
    this.activeIndex = null;
    this.bind();
  }

  CategoryDrill.prototype.bind = function () {
    var self = this;

    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        // Parent trigger is now a <button>, so no preventDefault needed —
        // first click drills down, second click on already-active parent
        // does nothing (Ryan's locked behavior). The semantic <button>
        // (vs <a>) tells screen readers correctly that this control
        // performs an in-page action, not navigation.
        var parent = trigger.closest('.ecore-drill__parent');
        if (!parent) return;
        var idx = parent.getAttribute('data-drill-parent');

        // Already-active parent: do nothing (don't navigate, don't toggle).
        if (self.activeIndex === idx) return;

        self.expand(parent, idx);
      });
    });

    if (this.backBtn) {
      this.backBtn.addEventListener('click', function () {
        self.collapse();
      });
    }

    this.section.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.activeIndex !== null) {
        e.preventDefault();
        self.collapse();
      }
    });
  };

  CategoryDrill.prototype.expand = function (parent, idx) {
    var self = this;
    // Mark previous active inactive (in case of switch)
    this.parents.forEach(function (p) {
      p.classList.remove('is-active');
      var trig = p.querySelector('[data-drill-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
      var subs = p.querySelector('.ecore-drill__subs');
      if (subs) subs.setAttribute('aria-hidden', 'true');
    });

    parent.classList.add('is-active');
    var trigger = parent.querySelector('[data-drill-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var subs = parent.querySelector('.ecore-drill__subs');
    if (subs) subs.setAttribute('aria-hidden', 'false');

    this.activeIndex = idx;
    this.section.setAttribute('data-state', 'expanded');
    this.section.setAttribute('data-active-parent', idx);
    if (this.backBtn) this.backBtn.hidden = false;

    // (OverlayScrollbars init removed — its DOM wrapping was distorting
    // the flex layout, squishing the active parent circle into an oval
    // and rendering a phantom vertical scrollbar. Native scrollbar via
    // CSS scrollbar-width:thin handles this without ever rendering the
    // < / > arrow buttons that the classic ::-webkit-scrollbar UI does.)

    // Restart cascade animation by re-applying the class
    if (subs) {
      subs.querySelectorAll('.ecore-drill__sub').forEach(function (li) {
        li.style.animation = 'none';
        // force reflow so the animation re-runs
        // eslint-disable-next-line no-unused-expressions
        li.offsetHeight;
        li.style.animation = '';
      });
    }
  };

  CategoryDrill.prototype.collapse = function () {
    if (this.activeIndex === null) return;

    var activeParent = this.section.querySelector('.ecore-drill__parent.is-active');
    this.parents.forEach(function (p) {
      p.classList.remove('is-active');
      var trig = p.querySelector('[data-drill-trigger]');
      if (trig) trig.setAttribute('aria-expanded', 'false');
      var subs = p.querySelector('.ecore-drill__subs');
      if (subs) subs.setAttribute('aria-hidden', 'true');
    });

    this.activeIndex = null;
    this.section.setAttribute('data-state', 'collapsed');
    this.section.removeAttribute('data-active-parent');
    if (this.backBtn) this.backBtn.hidden = true;

    // Return focus to the previously-active parent's link for keyboard users
    if (activeParent) {
      var trig = activeParent.querySelector('[data-drill-trigger]');
      if (trig) trig.focus();
    }
  };

  function init() {
    document.querySelectorAll('[data-ecore-drill]').forEach(function (section) {
      if (section.__ecoreDrillInit) return;
      section.__ecoreDrillInit = true;
      new CategoryDrill(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
